import React from 'react';
import CountUp from 'react-countup';

const dados = {
    anos: 10,
    departamentos: 4,
    membros: 93,
    leq: 200,
    meq: 150
}

function Statistics() {
    return (
        <section id="facts">
            <div className="container wow fadeIn">
                <div className="section-header">
                    <h3 className="section-title">O NEEQ-FEUP em números</h3>
                    <p className="section-description">Alguns dados numéricos representativos do nosso núcleo</p>
                </div>
                <div className="row counters justify-content-center">
                    <div className="col-lg-2 col-sm-6 col-12 text-center">
                        <CountUp end={dados.anos} delay={0.5} duration={2} />
                        <p className="text-center">Anos</p>
                    </div>
                    <div className="col-lg-2 col-sm-6 col-12 text-center">
                        <CountUp end={dados.departamentos} delay={0.6} duration={2} />
                        <p className="text-center">Departamentos</p>
                    </div>

                    <div className="col-lg-2 col-sm-6 col-12 text-center">
                        <CountUp end={dados.membros} delay={0.7} duration={2} />
                        <p className="text-center">Membros</p>
                    </div>
                </div>
                <div className="row counters justify-content-center">
                    <div className="col-lg-3 col-sm-6 col-12 text-center">
                        <CountUp end={dados.leq} delay={0.8} duration={2} />
                        <p className="text-center">Estudantes do LEQ</p>
                    </div>
                    <div className="col-lg-3 col-sm-6 col-12 text-center">
                        <CountUp end={dados.meq} delay={0.8} duration={2} />
                        <p className="text-center">Estudantes do MEQ</p>
                    </div>

                </div>

            </div>
        </section>
    );
}

export default Statistics;
